import Vue from 'vue';
import OSS from 'ali-oss';
import dayjs from 'dayjs';
import {apiGetOssConfig} from '@/request/API'
import md5 from 'js-md5'
import {OSSDecryptEbc} from "@/request/customer/util";
// 定义图片预览基准地址
const baseUrl = 'https://images.pxb7.com/'
let flag =false
/**
/ * 上传一个文件
*/
const uploadAction = async option => {
  // 获取临时凭证的请求
  let OSSdata = await apiGetOssConfig({
    source: 'web',
    sign:  md5('web_pxb7_666_888_!@bc')
  })
  let data = JSON.parse(OSSDecryptEbc(OSSdata.data.data, 'pxb7f0XkT845B666'))
  //从后台拿到的临时授权信息
  let client = new OSS.Wrapper({
    region: "oss-cn-hangzhou",
    accessKeyId: data.Credentials.AccessKeyId,
    accessKeySecret: data.Credentials.AccessKeySecret,
    stsToken: data.Credentials.SecurityToken,
    bucket: data.bucket
  });

  let filePath = 'images/' + option.fileDir+'/'+dayjs(new Date()).format('YYYYMMDD') + '/'+option.fileName;
  return client.multipartUpload(
    filePath,
    option.file, {
      //上传过程回调，参数为(上传文件信息，上传百分比)，可通过option的progress属性传递自定义操作，默认为打印当前上传进度
      progress: function* (p) {
        // (option.progress || console.log)(option.file, 'Uploading Progress: ' + p * 100)
        // if(p*100===100){
        //   Message.success('图片上传成功')
        // }
      }
    }
  )
}

/**
 * 上传多个文件
 */
const uploadFiles = async (files, fileDir, progress = console.log) => {
  let urls = [];
  for (let index = 0; index < files.length; index++) {
    let randomNum = ('00000' + Math.floor(Math.random() * 99999)).slice(-5)
    let suffix = files[index].raw.type.split('/')[1]?files[index].raw.type.split('/')[1]:'jpg'
    let res = await uploadAction({
      //待上传文件信息
      file: files[index].raw,
      // 上传文件路径
      fileDir:fileDir,
      //上传文件名称，为防止文件被覆盖（oss上传重复文件会覆盖同名文件），使用年月日时分秒_5位随机数.后缀
      fileName: dayjs(new Date()).format('YYYYMMDDHHmmss')+'_'+randomNum+'.'+suffix,
	  //可选参数，图片上传过程中触发的操作
      progress: progress
    });
    if (res.name) {
      urls.push(`${baseUrl}${res.name}`);
      files[index].url=`${baseUrl}${res.name}`
    }
  }
  //返回多个文件上传结果，为多个oss文件路径地址（不包含host路径）
  return {urls,files};
}

export default {
  uploadFiles,
  uploadAction,
  baseUrl
}

Vue.prototype.$upload = uploadFiles;

// 组件中使用例子
// methods: {
//     async upload (files, dir) {
//       //上传完成后的图片地址
//       let urls = await this.$upload(files, dir);
//       console.log(urls);
//     }
//   },